export default "__VITE_ASSET__Crs_04Ns__"